document.addEventListener('DOMContentLoaded', function() {

    const el = document.querySelector('.js-book');

    const init = function() {

        const btn = el.querySelectorAll('.js-btn'),
              cols = el.querySelector('.o-cols');

        const action = function(e) {
            let _this = e.currentTarget;

            for (let i = 0; i < btn.length; i++) {
                btn[i].classList.remove('is-active');
            }
            
            cols.classList.remove('fade-in');
            
/*
            let viewportOffset = document.querySelector('.c-book .o-cols').getBoundingClientRect().top;
            scroll({
                top: viewportOffset + window.scrollY - document.querySelector('.js-topbar').clientHeight - 20,
                behavior: "smooth"
            })   
*/         
            
            setTimeout(() => {            
                cols.classList.remove('shops', 'contact');
                cols.classList.add(_this.getAttribute('href'));
                _this.classList.add('is-active');
            }, 10);

            setTimeout(() => {
                cols.classList.add('fade-in');
            }, 150);

            e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
        }
        
        for (let i = 0; i < btn.length; i++) {
            btn[i].addEventListener('click', action);
        }
    };
    
    el ? init() : false;

}, false);
